import styled from 'styled-components'

import { RewardsCard as RewardsCardComponent } from '../../RewardsCard'
import { RewardsHeading2, RewardsHeading4 } from '../../RewardsHeading'
import { RewardsVipDiscountCard } from '../../RewardsVipDiscountCard'
import { YourRewardsCard as YourRewardsCardComponent } from '../YourRewardsCard'

export const Card = styled(RewardsCardComponent)`
  gap: 24px !important;
`

export const Heading2 = styled(RewardsHeading2)`
  margin-bottom: 0;
  margin-right: 8px;
`

export const Heading4 = styled(RewardsHeading4)`
  margin-bottom: 0;
  margin-right: 0;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: 1280px) {
    flex-direction: row;
  }
`

export const YourRewardsCard = styled(YourRewardsCardComponent)`
  width: 100%;
`

export const VipDiscountCard = styled(RewardsVipDiscountCard)`
  width: 100%;
  min-width: 35%;
  @media (min-width: 1280px) {
    width: 30%;
  }
`
